import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Contact from '@/pages/home/components/Contact';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://grainn-office.com';

const contactJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'ContactPage',
      '@id': `${siteUrl}/contact#webpage`,
      url: `${siteUrl}/contact`,
      name: '大阪 経営コンサルティング 無料相談・お問い合わせ｜GRAINN',
      description: 'GRAINNへのお問い合わせはこちら。WEBサイト制作・SNS運用代行・デジタルマーケティングの初回相談は無料です。大阪・全国オンライン対応可能。',
      inLanguage: 'ja',
      isPartOf: { '@id': `${siteUrl}/#website` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'ホーム', item: `${siteUrl}/` },
          { '@type': 'ListItem', position: 2, name: 'お問い合わせ', item: `${siteUrl}/contact` },
        ],
      },
    },
  ],
};

export default function ContactPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="min-h-screen">
      <title>大阪 経営コンサルティング 無料相談・お問い合わせ｜GRAINN</title>
      <meta name="description" content="GRAINNへのお問い合わせはこちら。WEBサイト制作・SNS運用代行・デジタルマーケティングの初回相談は無料です。大阪・全国オンライン対応可能。" />
      <link rel="canonical" href={`${siteUrl}/contact`} />
      <JsonLd data={contactJsonLd} id="contact" />
      <Navbar />

      {/* Page Hero */}
      <section className="relative pt-44 pb-24 overflow-hidden bg-[#1C2B22]">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=minimalist%20dark%20green%20elegant%20business%20communication%20laptop%20phone%20notebook%20desk%20top%20view%20flat%20lay%20professional%20Japanese%20aesthetic%20warm%20light&width=1920&height=600&seq=contact-hero-bg&orientation=landscape"
            alt="お問い合わせ"
            className="w-full h-full object-cover object-top opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#1C2B22]/80 to-[#1C2B22]" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
          <p className="text-[#C9A878] text-xs tracking-[0.4em] mb-5 uppercase">/ Contact</p>
          <h1 className="text-5xl md:text-7xl font-bold text-white tracking-tight leading-tight mb-6">
            お問い合わせ
          </h1>
          <div className="w-16 h-px bg-[#C9A878]/60 mb-6" />
          <p className="text-white/60 text-lg max-w-xl leading-relaxed">
            初回ご相談は無料です。お気軽にご連絡ください。
          </p>
          <div className="flex items-center gap-2 mt-8 text-xs text-white/30">
            <Link to="/" className="hover:text-white/60 transition-colors">ホーム</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-white/60">お問い合わせ</span>
          </div>
        </div>
      </section>

      <Contact />
      <Footer />
    </main>
  );
}
